import { IconInfoCircleOutline } from '@iwoca/icons';
import { AlertBox, Text } from '@iwoca/orion';
import { NEW_IwLink } from '@iwRouter/NEW_IwLink';
import { FormattedMessage } from 'react-intl';

import { CREDIT_CARD_BASE_URL } from '../constants';

export const AccountActivationConfirmation = () => {
    return (
        <div className="flex flex-col items-center bg-structure-100 py-2xl">
            {/* Main content */}
            <div className="text-center">
                <Text className="mb-m text-3xl font-bold">
                    <FormattedMessage
                        id="_.credit_card.onboarding.complete.title"
                        defaultMessage="You're all set and ready to go!"
                    />
                </Text>
                <Text className="my-xl text-xl font-reg text-primary-10">
                    <FormattedMessage
                        id="_.credit_card.onboarding.complete.description"
                        defaultMessage="Download our app to manage your card and view card details."
                    />
                </Text>
            </div>

            {/* Info alert */}
            <AlertBox className="mb-2xl flex w-[400px] max-w-2xl flex-row gap-s max-sm:w-full">
                <IconInfoCircleOutline className="my-auto flex-shrink-0" />
                <Text className="text-s font-med">
                    <FormattedMessage
                        defaultMessage="Your virtual card will be available to use immediately."
                        id="_.credit_card.onboarding.complete.virtual_card_info"
                    />
                </Text>
            </AlertBox>

            {/* App store badges and QR codes */}
            <div className="gap-8 mb-3xl grid grid-cols-2 items-start">
                {/* Apple App Store */}
                <div className="col-span-1 my-auto flex flex-col items-center gap-m">
                    <a
                        href="https://apps.apple.com/gb/app/iwoca/id6757226535"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="transition-opacity hover:opacity-80"
                    >
                        <img
                            src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83"
                            // eslint-disable-next-line formatjs/no-literal-string-in-jsx
                            alt="Download on the App Store"
                            className="h-[70px] w-full"
                        />
                    </a>
                </div>

                {/* Google Play Store */}
                <div className="col-span-1 my-auto flex flex-col items-center gap-m">
                    <a
                        href="https://play.google.com/store/apps/details?id=com.iwoca.wallet&hl=en_GB"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="transition-opacity hover:opacity-80"
                    >
                        <img
                            src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                            // eslint-disable-next-line formatjs/no-literal-string-in-jsx
                            alt="Get it on Google Play"
                            className="h-[100px] w-full"
                        />
                    </a>
                </div>
            </div>

            {/* Dashboard link */}
            <div className="flex flex-row gap-s">
                <Text className="text-m font-reg text-structure-60">
                    <FormattedMessage
                        id="_.credit_card.onboarding.complete.go_to_dashboard"
                        defaultMessage="or "
                    />
                </Text>
                <NEW_IwLink to={{ pathname: CREDIT_CARD_BASE_URL }}>
                    <Text className="text-m font-reg text-primary-40 underline">
                        <FormattedMessage
                            id="_.credit_card.onboarding.complete.dashboard_link"
                            defaultMessage=" view your online credit card dashboard"
                        />
                    </Text>
                </NEW_IwLink>
            </div>
        </div>
    );
};
